import { normalizePillFilterValue, isPillFilterActive } from "./screenerStateStorage";
import { REGION_FR_TO_EN } from "./invelpsRegions";

/** Schéma fixe — ne doit pas dépendre des lignes chargées (évite boucles de fetch). */
export const SCREENER_FILTER_SCHEMA = [
  { id: "signal", type: "pills", regionFr: false },
  { id: "moat", type: "pills", regionFr: false },
  { id: "capClass", type: "pills", regionFr: false },
  { id: "region", type: "pills", regionFr: true },
  { id: "country", type: "pills", regionFr: false },
  { id: "sector", type: "pills", regionFr: false },
  { id: "structTone", type: "pills", regionFr: false },
  { id: "marcheStatus", type: "pills", regionFr: false },
  { id: "moatStatus", type: "pills", regionFr: false },
  { id: "rrQ", type: "pills", regionFr: false },
  { id: "distSt", type: "pills", regionFr: false },
  { id: "minIscore", type: "range", min: 0, max: 100, isMax: false },
  { id: "minYes", type: "range", min: 0, max: 6, isMax: false },
  { id: "minFund", type: "range", min: 0, max: 100, isMax: false },
  { id: "minEVA", type: "range", min: -20, max: 60, isMax: false },
  { id: "minSolv", type: "range", min: 0, max: 100, isMax: false },
  { id: "minMos", type: "range", min: -80, max: 50, isMax: false },
  { id: "minFcfY", type: "range", min: 0, max: 20, isMax: false },
  { id: "maxPeg", type: "range", min: 0, max: 5, isMax: true },
  { id: "minTs", type: "range", min: 0, max: 100, isMax: false },
  { id: "minMom3m", type: "range", min: -40, max: 40, isMax: false },
  { id: "minRsi", type: "range", min: 0, max: 100, isMax: false },
  { id: "minCagr5y", type: "range", min: -20, max: 70, isMax: false },
  { id: "minDD", type: "range", min: -80, max: 0, isMax: false },
  { id: "minSharpe", type: "range", min: -1, max: 3, isMax: false },
  { id: "minErProxy", type: "range", min: -10, max: 15, isMax: false },
  { id: "minCfo", type: "range", min: 0, max: 110, isMax: false },
  { id: "minShY", type: "range", min: 0, max: 20, isMax: false },
  { id: "actCov", type: "bool" },
  { id: "outperf", type: "bool" },
];

/** Au moins un filtre actif (pills, bool ou range modifié). */
export function hasActiveScreenerFilters(fv) {
  if (!fv || typeof fv !== "object") return false;
  for (const f of SCREENER_FILTER_SCHEMA) {
    const v = fv[f.id];
    if (f.type === "pills" && isPillFilterActive(v)) return true;
    if (f.type === "bool" && v !== null && v !== undefined) return true;
    if (f.type === "range") {
      const def = f.isMax ? f.max : f.min;
      if (v !== def) return true;
    }
  }
  return false;
}

function appendPillParams(params, key, values, mapRegionFr = false) {
  const picks = normalizePillFilterValue(values);
  picks.forEach((v) => {
    if (mapRegionFr && REGION_FR_TO_EN[v]) {
      params.append(key, REGION_FR_TO_EN[v]);
    } else {
      params.append(key, v);
    }
  });
}

/** Construit les query params pour GET /capitalflow/screener */
export function buildScreenerQueryParams(fv) {
  const params = new URLSearchParams();
  if (!fv || typeof fv !== "object") return params;

  for (const f of SCREENER_FILTER_SCHEMA) {
    const v = fv[f.id];
    if (f.type === "pills") {
      appendPillParams(params, f.id, v, f.regionFr);
    } else if (f.type === "bool" && v !== null && v !== undefined) {
      params.set(f.id, v === true ? "1" : "0");
    } else if (f.type === "range") {
      const def = f.isMax ? f.max : f.min;
      if (v !== def) params.set(f.id, String(v));
    }
  }
  return params;
}

/** Clé stable pour déclencher un fetch uniquement quand les filtres changent. */
export function screenerFiltersQueryKey(fv) {
  return buildScreenerQueryParams(fv).toString();
}

export async function fetchScreener(baseUrl, fv) {
  const base = (baseUrl || "").replace(/\/$/, "");
  if (!base) return { rows: [], filterOptions: {}, meta: {} };

  const params = buildScreenerQueryParams(fv);
  const url = `${base}/capitalflow/screener${params.toString() ? `?${params}` : ""}`;
  const t0 = typeof performance !== "undefined" ? performance.now() : 0;
  const r = await fetch(url);
  if (!r.ok) throw new Error(String(r.status));
  const j = await r.json();
  const elapsedMs =
    typeof performance !== "undefined" ? Math.round(performance.now() - t0) : null;
  return {
    rows: Array.isArray(j.rows) ? j.rows : [],
    filterOptions: j.filterOptions || {},
    meta: { ...(j.meta || {}), elapsedMs },
  };
}
